<div class="flex-column gap attendance-candidates-dialog">
    <app-date-scroller-input [formField]="formDef.date"></app-date-scroller-input>

    @if (candidates().length) {
        <div class="candidate-grid">
            @for (candidate of candidates(); track candidate.personId) {
                <app-attendance-candidate-card
                    [candidate]="candidate"
                    (confirmAttendance)="confirmAttendance($event)"
                    (checkout)="checkout($event)"
                ></app-attendance-candidate-card>
            }
        </div>
    } @else if (store.loadingAny()) {
        <app-loading></app-loading>
    } @else {
        <app-empty-state></app-empty-state>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonVisibility]="false"
        secondaryButtonLabel="common.close"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
